import key from "keymaster";

$(document).on("turbolinks:load", () => {
  key("ctrl+shift+o", (e) => {
    e.preventDefault();
    $("#organization-impersonate").modal("show");
  });
});
